<script setup lang="ts">
import { computed, toRefs, withDefaults, defineProps } from "vue"
import { icons } from "@/assets/icons"

console.log("LOADED ICON VALUE:", icons["media/microphone/outline"])
import type { IconKey } from "@/assets/icons"

// Типы пропсов
interface Props {
  name: IconKey
  size?: number | string
  color?: string
  class?: string
}

// Значения по умолчанию
const props = withDefaults(defineProps<Props>(), {
  size: 20,
  color: "currentColor",
  class: ""
})

// Нужен toRefs, чтобы TS правильно понимал реактивность
const { name, size, color } = toRefs(props)

// Accept both `:size="16"` and `size="16"` (numeric string): bare numbers get "px".
const cssSize = computed(() => /^\d+(\.\d+)?$/.test(String(size.value)) ? `${size.value}px` : String(size.value))

const svg = computed(() => {
  const value = icons[name.value]
  if (!value && import.meta.env?.DEV) {
    console.warn(`[LibIcon] Icon not found: "${name.value}"`)
  }
  return value
})
</script>

<template>
  <span
      v-if="svg"
      class="inline-block"
      :style="{
      width: cssSize,
      height: cssSize,
      color: color
    }"
      v-html="svg"
      :class="props.class"
  />
</template>

<style scoped>
span :deep(svg) {
  width: 100%;
  height: 100%;
  fill: currentColor;
}
</style>
